import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, concatMap, filter, map } from 'rxjs/operators';
import { LDFeatureManager } from 'src/app/shared/services/ld-feature-manager';
import { ProfessionTree } from '../../models/profession-tree.model';
import {
    loadProfessionTree,
    loadProfessionTreeFailure,
    loadProfessionTreeSuccess
} from '../actions/profession-specialty-configuration.actions';
import { selectProfessionTree } from '../selectors/profession-specialty-configuration.selector';
import { DocumentAdminClient } from '../../api/document-admin-client.service';
import { ProfessionTreeDto } from '../../api/models/profession-tree-dto.model';

@Injectable()
export class ProfessionSpecialtyConfigurationEffects {
    loadProfessionSpecialtyConfigurations$ = createEffect(() => {
        const { actions$, docAdminService, store, featureManager } = this;

        const fetch$ = docAdminService.getProfessionTree().pipe(
            map((data: ProfessionTreeDto) => {
                const transformedData = data as unknown as ProfessionTree;
                return loadProfessionTreeSuccess({ data: transformedData });
            }),
            catchError((error) => {
                error = error?.message ?? 'Failed to load professions and specialties.';
                return of(loadProfessionTreeFailure({ error }));
            })
        );

        return actions$.pipe(
            ofType(loadProfessionTree),
            concatLatestFrom(() => store.select(selectProfessionTree)),
            filter(([action, tree]) => action.force === true || !tree),
            concatMap(() => fetch$)
        );
    });

    constructor(
        private readonly store: Store,
        private readonly actions$: Actions,
        private readonly docAdminService: DocumentAdminClient,
        private readonly featureManager: LDFeatureManager
    ) {}
}
